import { useEffect } from "react";
import { setPageMeta } from "@/lib/api";
import { Reveal } from "@/components/Motion";
import { CoachChat } from "@/components/CoachChat";

export default function Coach() {
  useEffect(() => {
    setPageMeta({
      title: "NRC Coach — AI Training, Gear & Club Help | Ninja Run Club",
      description: "Ask NRC Coach anything: training plans and pacing, which city tee and size to get, or which run club fits you. Free, instant, no login needed.",
      path: "/coach",
    });
  }, []);
  return (
    <div className="bg-night min-h-screen" data-testid="coach-page">
      <header className="px-5 lg:px-10 pt-12 pb-8 border-b border-white/10">
        <Reveal>
          <p className="font-mono-label text-white/40">ALWAYS ON</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-none uppercase">NRC Coach.</h1>
          <p className="text-white/60 text-sm max-w-2xl mt-5 leading-relaxed">
            Training plans, pacing, race prep. The right tee, the right size, shipping and drops. Which run club fits you.
            One coach, every question — no login needed.
          </p>
        </Reveal>
      </header>
      <div className="px-5 lg:px-10">
        <div className="max-w-3xl mx-auto h-[62vh] min-h-[420px] flex flex-col min-h-0 overflow-hidden">
          <CoachChat />
        </div>
      </div>
      <div className="h-10" />
    </div>
  );
}
